// client/src/coms/components/ComsModal.js
import React, { useEffect } from 'react';

export default function ComsModal({
  title,
  children,
  onClose,
  footer,
  className,
  width,
  maxWidth,
}) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const modalStyle = {
    width: width || '460px',
    maxWidth: maxWidth || 'calc(100vw - 30px)',
  };

  return (
    <div className="coms-modal-backdrop" onMouseDown={onClose}>
      <div
        className={`coms-modal${className ? ` ${className}` : ''}`}
        onMouseDown={(e) => e.stopPropagation()}
        style={modalStyle}
      >
        <div className="coms-modal-header">
          <div className="coms-modal-title">{title}</div>
          <button type="button" className="coms-mini-btn" onClick={onClose} title="Close">
            ✕
          </button>
        </div>

        <div className="coms-modal-body">
          {children}
        </div>

        {footer ? (
          <div className="coms-modal-footer">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}